/**
 * Order numbers: `482 913 057`.
 *
 * An order's `display_id` is six to nine digits; a later visit of a course
 * adds `-2`, `-3`. For reading aloud the digits are grouped in threes from
 * the right. What is copied or searched for is the digits alone.
 */
import { groupThousands } from "./money";

const NUMBER = /^(\d{6,9})(-\d+)?$/;

export function formatOrderNumber(value: string): string {
  const match = NUMBER.exec(value.trim());
  if (match === null) return value;
  return `${groupThousands(match[1] ?? "")}${match[2] ?? ""}`;
}

/**
 * The digits of what a person typed as an order number (`482 913 057`,
 * `482913057`), or null when it is not one.
 */
export function parseOrderNumber(input: string): string | null {
  const digits = input.replace(/\s/g, "");
  return /^\d{6,9}$/.test(digits) ? digits : null;
}
